import type { ZuubPayer } from '@/@types/zuub/contracts';
import { StatusChip } from '@/common-components/elements/StatusChip/StatusChip';

import type { StatusChipProps } from '../helpers/helpers';
import { PayerAvatar } from '../PayerAvatar';

interface PayerHeaderProps {
  payer: ZuubPayer;
  statusChipProps: StatusChipProps;
}

export const PayerHeader = ({ payer, statusChipProps }: PayerHeaderProps) => {
  return (
    <div className="vai-flex vai-items-center vai-justify-between vai-gap-4 vai-pb-6">
      <div className="vai-flex vai-items-center vai-gap-4">
        <PayerAvatar payer={payer} size="md" />
        <h2 className="vai-text-xl vai-font-semibold vai-text-gray-900">
          {payer.name}
        </h2>
      </div>
      <StatusChip
        text={statusChipProps.text}
        variant={statusChipProps.variant}
        icon={statusChipProps.icon}
      />
    </div>
  );
};
